import { EntitiesStore } from './entities-store.abstract';
import { HttpClient } from '@angular/common/http';
import { CountryDependencyEntityStore } from './country-dependency-entity-store';
import { Injector } from '@angular/core';


/**
 * Interface that represents an official
 *
 * @interface IOfficial
 */
export interface IOfficial {
  Id: string;
  FName: string;
  GName: string;
  WNameOrd: boolean;
  Age: number;
  Gender: string;
  Nationality: string;
  EntryMA: string;
  Association: IAssociation;
}

/**
 * Interface that represents an official Association
 *
 * @interface IAssociation
 */
export interface IAssociation {
  MAS: IMA[];
}

/**
 * Interface that represents the Function of an official
 *
 * @export
 * @interface IMA
 */
export interface IMA {
  FunCode: string;
  FunName: string;
  FunLevel: string;
  FunGroup: string;
  FunWaPosition: boolean;
  FunStart: string;
  FunEnd: string;
}

/**
 * Store for getting the officials
 *
 * @export
 * @class OficialsStore
 * @extends {EntitiesStore<IOfficial>}
 */
export class OficialsStore extends EntitiesStore<IOfficial>  {
  constructor(http: HttpClient, injector: Injector) {
    super('OFFICIALS', http, [{ entity: new CountryDependencyEntityStore(http, injector) }]);
  }
}
